import { Flex, Table, Tbody, Td, Th, Thead, Tr } from '@chakra-ui/react';
import { Iteration } from 'Component/others';
import SkeletonComponent from 'UiKit/skeleton';

export const FilterSkeleton = () => {
  return (
    <Flex justifyContent={'space-between'} width={'100%'} data-testid="filter-skeleton">
      <Flex gap={'8px'}>
        <SkeletonComponent height="34px" width="380px" />
        <SkeletonComponent height="34px" width="200px" />
        <SkeletonComponent height="34px" width="170px" />
        <SkeletonComponent height="34px" width="170px" />
      </Flex>
      <SkeletonComponent height="34px" width="100px" />
    </Flex>
  );
};

export const TableSkeleton = () => {
  return (
    <Table>
      <Thead>
        <Tr>
          <Th width="130px">
            <Flex justifyContent="space-between">
              <SkeletonComponent height="21px" width="60%" />
              <SkeletonComponent height="21px" width="21px" />
            </Flex>
          </Th>
          <Th width="130px">
            <Flex>
              <SkeletonComponent height="21px" width="50%" mb="2px" />
              <SkeletonComponent height="21px" width="21px" />
            </Flex>
          </Th>
          <Th width="180px">
            <Flex>
              <SkeletonComponent height="21px" width="50%" mb="2px" />
              <SkeletonComponent height="21px" width="21px" />
            </Flex>
          </Th>
          <Th width="200px">
            <Flex>
              <SkeletonComponent height="21px" width="50%" mb="2px" />
              <SkeletonComponent height="21px" width="21px" />
            </Flex>
          </Th>
          <Th width="130px">
            <Flex>
              <SkeletonComponent height="21px" width="50%" mb="2px" />
              <SkeletonComponent height="21px" width="21px" />
            </Flex>
          </Th>
          <Th width="150px">
            <Flex>
              <SkeletonComponent height="21px" width="50%" mb="2px" />
              <SkeletonComponent height="21px" width="21px" />
            </Flex>
          </Th>
          <Th width="230px">
            <Flex>
              <SkeletonComponent height="21px" width="50%" mb="2px" />
            </Flex>
          </Th>
        </Tr>
      </Thead>
      <Tbody>
        <Iteration
          items={[1, 2, 3, 4, 5, 6, 7, 8, 9, 10]}
          render={(num) => {
            return (
              <Tr key={num}>
                <Td>
                  <SkeletonComponent height="21px" width="90%" mb="2px" />
                </Td>
                <Td>
                  <SkeletonComponent height="21px" width="90%" mb="2px" />
                </Td>
                <Td>
                  <SkeletonComponent height="21px" width="90%" mb="2px" />
                </Td>
                <Td>
                  <SkeletonComponent height="21px" width="90%" mb="2px" />
                </Td>
                <Td>
                  <SkeletonComponent height="21px" width="90%" mb="2px" />
                </Td>
                <Td>
                  <SkeletonComponent height="21px" width="90%" mb="2px" />
                </Td>
                <Td>
                  <SkeletonComponent height="21px" width="90%" mb="2px" />
                </Td>
                <Td>
                  <SkeletonComponent height="21px" width="90%" mb="2px" />
                </Td>
                <Td>
                  <SkeletonComponent height="21px" width="90%" mb="2px" />
                </Td>
              </Tr>
            );
          }}
        />
      </Tbody>
    </Table>
  );
};
